import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';

@Component({
    selector: 'app-crm-tasks-widget',
    templateUrl: './crm-tasks-widget.component.html',
    styleUrl: './crm-tasks-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppCrmTasksWidgetComponent {
    @Input() widgetData: WidgetModel
}
